import { render, staticRenderFns } from "./MemberOrder.vue?vue&type=template&id=185213d2&"
import script from "./MemberOrder.vue?vue&type=script&lang=js&"
export * from "./MemberOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports